export const MOVE_CUBUK_WIDTH = 2; // px
